module.exports = __webpack_public_path__ + "static/media/CGR Academy Brochure..3c6260ac.pdf";